import { ComponentProps, ReactNode, useState } from 'react';

import HeightToggle from '../../../../../components/HeightToggle/HeightToggle';
import Inline from '../../../../../components/Inline/Inline';
import Title from '../../../../../components/Title/Title';
import useTrans from '../../../../../hooks/ui/useTrans';
import FormDimmableCard from '../../../../components/FormDimmableCard/FormDimmableCard';
import BookingParameters from '../../../../types/BookingParameters';
import FilterToggle from '../FilterToggle/FilterToggle';

type BoatModelFiltersCardProps = {
    title?: ReactNode;
    parameters?: BookingParameters;
} & ComponentProps<typeof FormDimmableCard>;

const BoatModelFiltersCard = ({
    title,
    parameters,
    children,
    ...cardProps
}: BoatModelFiltersCardProps) => {
    const trans = useTrans('CustomerArea.BookingForm.BoatModel.');
    const [showingFilters, setShowingFilters] = useState(false);

    return (
        <>
            <FormDimmableCard {...cardProps}>
                <Inline vertical="middle" horizontal="justify">
                    {title && <Title variant="area">{title}</Title>}
                    <FilterToggle
                        onClick={() => setShowingFilters(!showingFilters)}
                    >
                        {trans('FilterToggleLabel')}
                    </FilterToggle>
                </Inline>
            </FormDimmableCard>
            <HeightToggle show={showingFilters}>
                <FormDimmableCard
                    {...cardProps}
                    variant="tint"
                    verticalPadding="small"
                >
                    {children}
                </FormDimmableCard>
            </HeightToggle>
        </>
    );
};

export default BoatModelFiltersCard;
